let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("cTHgP")).then(() => parcelRequire('3VDpf'));